import { LOAD_FRIENDS, CHANGE_FRIEND_STATUS } from "../actions";
import { User } from "../types";
import { findIndex, propEq } from "ramda";

export const initialState = {
	friends: [] as Array<User>,
	feed: [],
};

export type SocialState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case LOAD_FRIENDS: {
			const friends = action.friends;
			return { ...state, friends };
		}

		case CHANGE_FRIEND_STATUS: {
			const friend = action.friend;

			let friends = state.friends;
			const index = findIndex(propEq("userId", friend.userId))(friends);
			friends[index] = friend;

			return { ...state, friends };
		}

		default:
			return state;
	}
}
